/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { func } from 'prop-types';
import {
	Form, Button, Upload,
} from 'antd';
import { validateMessages } from '../../utils/validateMessages';
import { UploadOutlined } from '@ant-design/icons';
import { getHeader, getBaseUrl } from '../../services/API'
import { CREATE_INSPECTIONAPPLICATIONS_PATH } from '../../services/paths'
import { showMessage } from '../../utils/messageUtils';
import { ERROR , SUCCESS} from '../../utils/constants';

const formItemLayout = {
	labelCol: {
		span: 6,
	},
	wrapperCol: {
		span: 14,
	},
};

const normFile = (e) => {
	if (Array.isArray(e)) {
		return e;
	}
	return e && e.fileList;
};

const NewInspectionsApplicationForm = () => {
	return (
		<Form
			name="validate_other"
			{...formItemLayout}
			validateMessages={validateMessages}
		>

			<Form.Item
				name="spreadsheet"
				label="Cargar: "
				type="file"
				valuePropName="fileList"
				getValueFromEvent={normFile}
				extra="Sólo permite hojas de cálculo"
			>

				<Upload name="spreadsheet"
					action={getBaseUrl() + CREATE_INSPECTIONAPPLICATIONS_PATH}
					headers={getHeader()}
					showUploadList={{showPreviewIcon: false, showDownloadIcon: false, showRemoveIcon: false}}
					
					accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
					style={{ width: '100%' }}

					onChange={(info) => {
						if (info?.file?.status == "error"){
							showMessage( { type: ERROR, msg: info?.file?.response?.message } )
						}

						if (info?.file?.status == "done"){
							showMessage( { type: SUCCESS, msg: info?.file?.response?.message } )
						}
					}}
					>
					<Button icon={<UploadOutlined />}>Archivo Excel</Button>
				</Upload>
			</Form.Item>
		</Form>
	)
};

NewInspectionsApplicationForm.propTypes = {};

NewInspectionsApplicationForm.defaultProps = {
	isLoading: false
};

export default NewInspectionsApplicationForm;
